import { call, put } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import { ActionType } from 'typesafe-actions';

import { Notifications } from 'types';
import { webSocketService } from 'services/WebSocketService';
import { addNewCardAction, setHasUndefinedCardToStore } from 'data/reducers';

export function* addNewCardSaga({ payload: { barcode } }: ActionType<typeof addNewCardAction>) {
  try {
    yield put(setHasUndefinedCardToStore(false));

    const { type, data } = yield call(() =>
      webSocketService.sendMessage({
        type: Notifications.ADD_NEW_CARD,
        data: { barcode: barcode.trim() },
      }),
    );

    if (type === 'ERROR' && data?.reason === 'NOT_REGISTERED') {
      yield put(setHasUndefinedCardToStore(true));
    }
  } catch (error) {
    Sentry.captureException(error);
  }
}
